import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { colorGroups, spacers, layoutScale, typography } from './uiSystem.data';

@Component({
  selector: 'hdi-ui',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ui.component.html',
  styleUrl: './ui.component.scss',
})
export class UiComponent {
  colorGroups = colorGroups;
  spacers = spacers;
  layoutScale = layoutScale;
  typography = typography;

  @Input() categories: string[] = [
    'Colors',
    'Spacers',
    'Layout Scale',
    'Typography',
  ];
}
